<template>
  <div>
    <tabs pills
          type="secondary"
          style-type="list"
          tab-nav-classes="d-flex justify-content-end"
          tab-content-classes="tab-space">
      <tab-pane v-for="stat in stats"
                :key="stat.name"
                :before-change="() => getData(stat.name)"
                :title="$t(`generic.filters.${stat.name}`)"
                :id="stat.name">
        <div class="row d-flex justify-content-between">
          <div class="col-xl-3 col-lg-6">
            <stats-card :title="model.views"
                        :loading="statsLoading"
                        class="job-stats"
                        :small-title="$t('generic.views')"
                        type="info"
                        icon="nc-icon nc-chart-pie-36">
            </stats-card>
          </div>
          <div class="col-xl-3 col-lg-6">
            <stats-card :title="model.apply_start"
                        :loading="statsLoading"
                        class="job-stats"
                        :small-title="$t('generic.applyStart')"
                        type="info"
                        icon="nc-icon nc-tap-01">
            </stats-card>
          </div>
          <div class="col-xl-3 col-lg-6">
            <stats-card :title="model.applicants"
                        :loading="statsLoading"
                        class="job-stats"
                        type="success"
                        :small-title="$t('generic.applicants')"
                        icon="nc-icon nc-paper">
            </stats-card>
          </div>
          <div class="col-xl-3 col-lg-6">
            <stats-card :title="model.orders | toCurrency"
                        :loading="statsLoading"
                        class="job-stats"
                        type="danger"
                        :small-title="$t('generic.sales')"
                        icon="nc-icon nc-shop">
            </stats-card>
          </div>
        </div>
      </tab-pane>
    </tabs>

    <div>
      {{ job.order }}
    </div>

    <data-table :data="job ? job.job_boards : []"
                :entity="entity"
                :columns="columns"
                :show-pagination="false"
                :goToDetailsOnRowClick="false"
                :searchable="false"
                operations="refresh"
                ref="table">
      <h6 slot="table-header-left">
        {{$t('generic.jobBoards')}}
      </h6>
      <div slot="name" slot-scope="{row}" class="d-flex align-items-center" @click="navigateToDetails(row)">
        <base-avatar :src="row.logo" no-radius :name="row.name"></base-avatar>
        <span class="ml-2 text-default">{{row.name}}</span>
      </div>
      <div slot="url" slot-scope="{row}" class="url-cell">
        <a :href="row.url" target="_blank" rel="noopener">
          {{row.url}}
        </a>
      </div>
      <status-badge slot="status" slot-scope="{row}" :status="row.status"/>
      <template slot="extra-buttons" slot-scope="{row}">
        <el-tooltip :content="$t('job.details.dashboard.goToJob')" placement="top-start">
          <base-button outline
                       icon size="sm"
                       @click="goToExternalJob(row.slug)">
            <i class="fas fa-link"></i>
          </base-button>
        </el-tooltip>
      </template>
    </data-table>

  </div>
</template>
<script>
  import { Tabs, TabPane, StatsCard } from 'src/components';
  import { mapState } from 'vuex';
  import JobService from 'src/services/JobService';
  import entities from 'src/config/entities'
  import { getRouteName, routeTypes } from 'src/config/routeTypes'

  export default {
    name: 'job-dashboard',
    components: {
      Tabs,
      TabPane,
      StatsCard
    },
    data() {
      return {
        entity: entities.JOB_BOARD,
        statsLoading: false,
        activeStat: 'total',
        model: {
          views: 0,
          click_out: 0,
          apply_start: 0,
          applicants: 0,
          orders: 0
        },
        stats: [
          {
            name: 'total'
          },
          {
            name: 'month'
          },
          {
            name: 'week'
          },
          {
            name: 'today'
          },
        ]
      }
    },
    computed: {
      ...mapState('jobs', {
        job: state => state.currentJob
      }),
      columns() {
        return [
          {
            prop: "name",
            label: this.$t('jobBoard.list.labels.name'),
            minWidth: "150px",
            sortable: true
          },
          {
            prop: "url",
            label: this.$t('jobBoard.list.labels.url'),
            minWidth: "150px",
            sortable: true
          },
          {
            prop: "status",
            label: this.$t('jobBoard.list.labels.status'),
            minWidth: "100px",
            sortable: true,
            align: "center"
          }
        ]
      }

    },
    methods: {
      goToExternalJob(slug) {
        console.log(slug)
        window.open(this.job.job_boards_url[slug], '_blank')
      },
      navigateToDetails(row) {
        this.$router.push({
          name: getRouteName(routeTypes.DETAILS, this.entity),
          params: {
            id: row.id
          }
        })
      },
      async getData(id) {
        if(id !== this.activeStat) {
          this.statsLoading = true;
          this.activeStat = id;
          try {
            let {data} = await JobService.getKpi(this.$route.params.id, this.activeStat);
            this.model = data;
          } finally {
            this.statsLoading = false;
          }
        }
      }
    },
    async beforeRouteEnter(to, from, next) {
      try {
        let res = await JobService.getKpi(to.params.id);
        let data = res.data;
        if (data) {
          next(vm => {
            vm.model = data;
          })
        } else {
          next(vm => vm.error = 'No data');
        }

      } catch (e) {
        next(vm => vm.error = e);
      }
    }
  }
</script>
<style scoped>
</style>
